import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AddressModule } from '@vsolv/core/address/web';
import { UtilsModule } from '@vsolv/ui-kit/utils';
import { AppPageModule } from '@vsolv/vectors-ui/app-page';
import { BadgeModule } from '@vsolv/vectors-ui/badge';
import { BreadcrumbsModule } from '@vsolv/vectors-ui/breadcrumbs';
import { ButtonModule } from '@vsolv/vectors-ui/button';
import { CardModule } from '@vsolv/vectors-ui/card';
import { DialogModule } from '@vsolv/vectors-ui/dialog';
import { DividerModule } from '@vsolv/vectors-ui/divider';
import { FormsModule } from '@vsolv/vectors-ui/forms';
import { IconsModule } from '@vsolv/vectors-ui/icons';
import { InputModule } from '@vsolv/vectors-ui/input';
import { SelectModule } from '@vsolv/vectors-ui/select';
import { SkeletonModule } from '@vsolv/vectors-ui/skeleton';
import { ThemingModule } from '@vsolv/vectors-ui/theming';
import { TooltipModule } from '@vsolv/vectors-ui/tooltip';
import { TableModule } from '@vsolv/vectors/table';
import { StaffWebModule } from '@wsphere/staff/web';
import { ServiceProviderPickerComponent } from './components';
import { CreateServiceProviderDialog, ServiceProviderStatusDialog } from './dialogs';
import { ServiceProviderGuard } from './guards';
import { ServiceProviderPage, ServiceProvidersPage } from './pages';
import { ServiceProviderResolver } from './resolvers';
import { ServiceProviderService } from './services';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    UtilsModule,
    StaffWebModule,
    AddressModule,
    AppPageModule,
    BadgeModule,
    BreadcrumbsModule,
    ButtonModule,
    CardModule,
    DialogModule,
    DividerModule,
    FormsModule,
    IconsModule,
    InputModule,
    SelectModule,
    SkeletonModule,
    ThemingModule,
    TooltipModule,
    TableModule,
  ],
  providers: [ServiceProviderService, ServiceProviderResolver, ServiceProviderGuard],
  declarations: [
    ServiceProvidersPage,
    ServiceProviderPage,
    CreateServiceProviderDialog,
    ServiceProviderStatusDialog,
    ServiceProviderPickerComponent,
  ],
  exports: [
    ServiceProvidersPage,
    ServiceProviderPage,
    CreateServiceProviderDialog,
    ServiceProviderStatusDialog,
    ServiceProviderPickerComponent,
  ],
})
export class ServiceProvidersWebModule {}
